module.exports = __webpack_public_path__ + "static/ziggy_report-tc-34c1d0462c255d8386f135127de233d5.png";